import React from 'react';
import { PropTypes } from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import { FilterChip } from '../atoms/FilterChip';

const useFilterChipListStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  }
}));

export const FilterChipList = ({ chips = [] }) => {
  const classes = useFilterChipListStyles();

  if (chips.length === 0) return null;

  return (
    <Box className={classes.container}>
      {chips.map(({ key, label, onRemove }) => (
        <FilterChip key={key} label={label} onDelete={onRemove} />
      ))}
    </Box>
  );
};

FilterChipList.propTypes = {
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]).isRequired,
      onRemove: PropTypes.func
    })
  )
};
